import { useEffect } from 'react';

// Minimal per-page SEO: sets document title + meta description.
export default function useSeo({ title, description, keywords }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description);
    }
    if (keywords) {
      let kt = document.querySelector('meta[name="keywords"]');
      if (!kt) {
        kt = document.createElement('meta');
        kt.setAttribute('name', 'keywords');
        document.head.appendChild(kt);
      }
      kt.setAttribute('content', keywords);
    }
  }, [title, description, keywords]);
}
